import coverCompany from '@/assets/img/conpany.png'
import coverRom1 from '@/assets/img/rom1.png'
import coverRom2 from '@/assets/img/rom2.png'
import coverRom3 from '@/assets/img/rom3.png'

export const articles = [
  {
    slug: 'cma-extend-2023',
    category: '公司新闻',
    title: '国测获聘河南省计量测试学会理事单位',
    date: '2025-01-15',
    excerpt: '携手行业同仁，共筑计量检测事业新发展，国测正式成为学会理事单位。',
    cover: require("@/assets/guoce/news-council.jpeg"),
    content: `
      <p>近日，国测检测顺利完成2023年度CMA资质扩项评审。评审组对我司质量管理体系运行、检测能力、人员资质、设备设施等方面进行了全面审核，一致认为我司管理体系运行有效，技术能力满足相应标准要求。</p>
      <p>本次扩项评审从“体系运行的有效性”与“技术能力的可验证性”两条主线展开：一方面核查文件化体系与现场执行的一致性，另一方面通过见证试验、记录追溯、人员操作规范性等环节，验证关键项目的稳定性与可靠性。</p>
      <p>为做好迎检准备，我司提前开展了内部审核与管理评审，对关键岗位能力、设备状态、方法适用性与不确定度评估等内容逐项梳理，并对发现的问题进行闭环整改，确保各环节符合要求。</p>
      <h3>评审范围与亮点</h3>
      <ul>
        <li>环境：新增地表水/地下水、有组织废气、土壤与沉积物等多项参数能力；</li>
        <li>食品与农产品：新增农药残留、兽药残留、食品添加剂与微生物等多项参数能力；</li>
        <li>公共卫生：新增集中空调通风系统卫生学评价相关项目；</li>
      </ul>
      <h3>能力建设与质量控制</h3>
      <ul>
        <li>人员能力：针对新增项目开展分层培训与上岗考核，确保关键岗位熟练掌握标准方法与操作要点；</li>
        <li>设备保障：完善设备台账与维护计划，规范期间核查与量值溯源，确保关键设备处于受控状态；</li>
        <li>过程管理：强化样品流转、原始记录、数据审核与报告签发的全过程控制，提升数据一致性；</li>
      </ul>
      <p>后续，国测检测将继续以客户需求为导向，持续投入方法学优化与能力拓展，进一步提升响应速度与服务体验，为客户提供更全面、更可靠的检测技术支持。</p>
      <blockquote>通过扩项评审有助于进一步提升我司服务广度和深度，更好地满足客户多样化检测需求。</blockquote>
    `
  },
  {
    slug: 'samr-daily-supervision-2024',
    category: '政策法规',
    title: '市场监管总局办公厅关于加强检验检测机构日常监管的通知',
    date: '2024-06-20',
    excerpt: '要求压实检验检测机构主体责任，强化全过程质量控制，完善“双随机、一公开”等监管机制。',
    cover: coverRom1,
    content: `
      <p>为进一步规范检验检测活动，市场监管总局办公厅印发通知，部署各地加强对检验检测机构的日常监管，提升数据真实性与结果公信力。通知强调以问题为导向，聚焦关键环节、关键人员与关键数据，形成“发现问题—督促整改—跟踪验证”的闭环管理。</p>
      <p>从监管思路上看，通知更加强调“全过程质量控制”与“可追溯、可核查、可复现”的工作要求：对样品受理、检测过程、数据处理、报告出具与留存等环节提出更高标准，推动行业从“合规满足”向“持续改进”转变。</p>
      <ul>
        <li>健全机构质量体系与人员能力管理；</li>
        <li>推广信息化手段开展监管与结果比对；</li>
        <li>对弄虚作假等违法行为依法严厉查处。</li>
      </ul>
      <h3>对机构日常管理的提示</h3>
      <ol>
        <li>强化原始记录与数据链条管理，确保每一步操作都有据可查、责任到人；</li>
        <li>对关键设备与关键试剂耗材建立风险清单，完善校准/期间核查与有效期管理；</li>
        <li>按项目特性设置质量控制点（空白、平行、加标回收、质控样等），并对异常结果开展复核；</li>
        <li>建立内部监督与自查机制，定期开展能力验证或比对试验，持续提升技术可靠性。</li>
      </ol>
      <p>国测检测将持续对标监管要求，进一步完善制度流程与信息化留痕，强化风险识别与预防机制，确保检测活动规范、客观、公正。</p>
      <p>来源：市场监管总局门户网站</p>
    `
  },
  {
    slug: 'cnas-2025-communication',
    category: '行业动态',
    title: '国测检测开展年度团队建设活动',
    date: '2025-01-15',
    excerpt: '以“团筑信赖，共创未来”为主题，凝聚专业团队力量。',
    cover: coverRom2,
    content: `
      <p>中国合格评定国家认可委员会（CNAS）发布认可计划动态提示，针对实验室认可评审中的共性问题给出改进建议，强调对关键量值溯源、能力验证与期间核查的持续符合性。提示内容覆盖体系运行、技术记录、人员能力与方法适用性等多个维度。</p>
      <p>从近期评审关注点来看，评审更重视“证据链”的完整与一致：既要有制度文件，也要能在现场记录、设备状态与人员操作中对应落实；既要有计划安排，也要能提供执行证据与效果验证。</p>
      <h3>常见关注点</h3>
      <ul>
        <li>人员能力：授权范围与实际操作能力是否匹配，培训与考核记录是否完整；</li>
        <li>设备管理：关键设备的校准/检定、期间核查、维护保养是否按计划实施；</li>
        <li>能力验证：参加计划的覆盖度、结果分析与纠正措施是否充分；</li>
        <li>方法与不确定度：方法验证/确认的适用性证据是否充分，关键项目不确定度评估是否合理。</li>
      </ul>
      <p>建议实验室结合自身业务特点建立风险点清单，开展针对性的内部审核与技术复核，确保体系与技术双线持续符合认可要求。</p>
      <p>来源：CNAS官网动态</p>
    `
  },
  {
    slug: 'gb-standard-update-2024',
    category: '行业动态',
    title: '国测检测顺利完成计量标准考核',
    date: '2024-11-30',
    excerpt: '专业能力与质量体系再获认可，持续夯实量值溯源基础。',
    cover: coverRom3,
    content: `
      <p>近期国家相关领域标准发布与修订较为频繁，涉及食品安全限量、环境监测方法等，建议行业机构提前评估方法学适配与能力覆盖，做好过渡安排。对于检验检测机构而言，标准更新往往意味着方法参数、质控要求、判定规则等同步调整，需要提前准备。</p>
      <h3>建议关注的工作</h3>
      <ul>
        <li>方法适配：对新旧方法差异点进行对比分析，必要时开展方法确认与验证；</li>
        <li>质量控制：根据标准要求调整质控频次与判定规则，完善记录表单与模板；</li>
        <li>能力覆盖：评估现有设备与人员能力是否满足新标准要求，必要时补齐短板；</li>
        <li>客户沟通：对报告判定依据、限值变化、过渡期安排进行说明，降低误解与争议。</li>
      </ul>
      <p>国测检测将持续跟踪标准动态，及时完成方法更新与能力确认，确保对外出具报告的依据最新、准确、可追溯。</p>
      <p>来源：国家标准公共服务平台</p>
    `
  },
  {
    slug: 'mee-lab-quality-2024',
    category: '政策法规',
    title: '生态环境领域监测实验室质量管理要求提示',
    date: '2024-09-18',
    excerpt: '聚焦监测数据质量控制与可追溯性，强调现场采样与实验分析全过程合规管理。',
    cover: require("@/assets/guoce/news-team.jpeg"),
    content: `
      <p>生态环境相关部门发布质量管理要求提示，要求严格落实采样、运输、保存、分析、记录与报告全流程的质量控制，确保数据真实、可靠、可追溯。提示内容强调“现场采样质量”与“实验室分析质量”同等重要，任何一个环节失控都可能影响最终结论。</p>
      <h3>全过程质量控制要点</h3>
      <ul>
        <li>采样环节：采样点位确认、采样器具清洁、现场空白/平行样设置与记录完整；</li>
        <li>运输保存：温度与保存条件控制，交接记录规范，防止样品污染与变质；</li>
        <li>实验分析：关键步骤设置质控点，仪器状态确认，校准曲线与质控样判定；</li>
        <li>数据审核：原始记录复核、计算过程复核、异常数据处理与说明；</li>
        <li>报告出具：依据、方法、判定规则清晰，结论可追溯，附件与原始记录留存完整。</li>
      </ul>
      <p>建议实验室以典型项目为切入点开展流程梳理与风险评估，建立可落地的质量控制清单，持续提升监测数据质量。</p>
      <p>来源：生态环境相关部门网站</p>
    `
  },
  {
    slug: 'reg-supervision-measures',
    category: '政策法规',
    title: '国家市场监管总局发布《检验检测机构监督管理办法》解读',
    date: '2023-09-28',
    excerpt: '办法强调数据真实性与可追溯性，完善资质管理与监督机制，违规惩戒更加严格。',
    cover: coverRom1,
    content: `
      <p>国家市场监督管理总局发布的《检验检测机构监督管理办法》旨在进一步规范检验检测活动，强化对检验检测机构的监督管理，推动行业高质量发展。</p>
      <p>该办法从机构设立、能力保持、质量控制、监督检查与法律责任等方面进行了系统规定，强调检验检测活动必须坚持独立、公正和科学原则，并通过制度化约束提升行业整体公信力。</p>
      <h3>主要内容要点</h3>
      <ol>
        <li>强调数据真实性、完整性和可追溯性，严禁提供虚假、篡改数据；</li>
        <li>完善机构资质管理要求，明确监督检查、抽查复查机制；</li>
        <li>对违法违规行为的处罚力度进一步加大，建立联合惩戒机制；</li>
      </ol>
      <h3>对企业与公众的意义</h3>
      <ul>
        <li>对委托方：检测服务更规范，报告质量与一致性更有保障；</li>
        <li>对公众：提升消费与公共安全相关检测结论的可信度；</li>
        <li>对行业：形成“守信受益、失信受限”的竞争环境，推动高质量发展。</li>
      </ul>
      <p>国测检测将严格遵循管理办法要求，持续完善质量体系，确保检测活动的规范性与公正性。</p>
    `
  },
  {
    slug: 'new-pollutant-action',
    category: '政策法规',
    title: '国务院办公厅印发《新污染物治理行动方案》要点',
    date: '2023-08-12',
    excerpt: '以重点管控为导向，完善治理制度体系，推进新污染物监测与技术能力建设。',
    cover: coverCompany,
    content: `
      <p>《新污染物治理行动方案》提出以重点管控为导向，完善新污染物治理制度体系，推进持久性有机污染物、内分泌干扰物、抗生素耐药性等领域的治理与监测。</p>
      <p>行动方案强调“源头管控—过程监管—末端治理”协同推进，并提出加强监测评估、风险筛查与技术支撑能力建设。对检验检测机构而言，新污染物治理将带动方法学研发、标准完善与高端仪器应用的持续需求。</p>
      <h3>对检测行业的影响</h3>
      <ul>
        <li>对新污染物监测能力提出更高要求；</li>
        <li>促进检测方法学研发和标准完善；</li>
        <li>推动产学研用协同创新与能力建设；</li>
      </ul>
      <h3>机构可开展的准备工作</h3>
      <ul>
        <li>建立重点物质清单与优先级，结合区域特点开展方法储备；</li>
        <li>完善样品前处理与基体干扰控制方案，提高低浓度检出能力；</li>
        <li>参与能力验证与比对试验，形成稳定可重复的数据输出能力；</li>
        <li>加强与高校/科研机构合作，推进方法学创新与标准转化。</li>
      </ul>
      <p>国测检测已开展新污染物相关分析方法的技术储备与验证，逐步拓展服务边界。</p>
    `
  },
  {
    slug: 'hr-health-week',
    category: '公司新闻',
    title: '“食品安全周”科普活动走进社区',
    date: '2023-09-10',
    excerpt: '走进社区开展食品安全知识普及与快检演示，提升公众食品安全意识。',
    cover: coverRom3,
    content: `
      <p>为提高公众食品安全意识，国测检测技术人员走进社区开展“食品安全周”科普活动，通过现场讲解、演示与互动问答，普及食品安全常识。</p>
      <p>活动现场设置了咨询台与演示区，工作人员以通俗易懂的方式讲解日常生活中常见的食品安全风险点，介绍如何查看标签信息、如何正确储存食品以及家庭自检的注意事项。居民可携带日常购买的蔬菜水果进行简单的快检演示互动。</p>
      <h3>活动内容</h3>
      <ul>
        <li>快速检测演示：蔬果农药残留快速筛查；</li>
        <li>知识普及：常见食品安全误区与防范要点；</li>
        <li>互动问答：居民现场咨询与报告解读；</li>
      </ul>
      <h3>常见问题解答摘录</h3>
      <ul>
        <li>如何减少农残摄入：合理清洗、浸泡、去皮与烹饪方式组合更有效；</li>
        <li>如何识别标签信息：关注配料表、生产日期、贮存条件与执行标准；</li>
        <li>保质期并非“绝对安全期”：开封后需按说明尽快食用并规范冷藏。</li>
      </ul>
      <p>后续将持续开展系列公益科普活动，传播科学检测理念。</p>
    `
  },
  {
    slug: 'lab-upgrade-ms',
    category: '技术创新',
    title: '引进高分辨质谱仪，能力进一步提升',
    date: '2023-09-10',
    excerpt: 'HRMS 投入使用，显著提升痕量污染物检测灵敏度并缩短检测周期。',
    cover: coverRom2,
    content: `
      <p>公司新引进的高分辨质谱仪（HRMS）已完成安装调试，将显著提升对痕量污染物的检测灵敏度与准确性，有助于缩短检测周期并拓展检测范围。</p>
      <p>相较于常规质谱平台，HRMS 具备更高的质量分辨率与质量准确度，可在复杂基体中实现更可靠的定性筛查与定量分析，尤其适用于未知物筛查、目标物扩展、微量污染物追踪等场景。</p>
      <h3>能力提升方向</h3>
      <ul>
        <li>多残留筛查：提升对农残、兽残、添加剂与环境污染物的覆盖广度；</li>
        <li>痕量追踪：更低检出限与更优的抗干扰能力，提高结果稳定性；</li>
        <li>方法拓展：支持非靶向筛查与可疑筛查，为风险识别提供数据支撑；</li>
      </ul>
      <p>该设备将重点服务于食品安全、环境监测、日化用品与医药研发等业务版块，助力为客户提供更高质量的技术服务。</p>
      <p>目前我司已同步完成关键人员培训、方法学适配与质控方案优化，确保新平台的检测结果满足准确性、重复性与可追溯性的要求。</p>
    `
  }
]

export const findArticleBySlug = (slug) => articles.find(a => a.slug === slug)
